import type { ReactElement } from "react"

import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined"
import { List } from "@mui/material"

import { DashboardMenuItem } from "../../../layouts/Dashboard/components/DashboardMenuItem"

import "../../../layouts/Dashboard/components/DashboardDrawer.module.scss"
import styles from "./Drawer.module.scss"

type Props = {
  onNewChat: () => void
}

export function KonanAssistantDrawer(props: Readonly<Props>): ReactElement {
  const { onNewChat } = props

  return (
    <nav aria-label="konan assistant chats" className={styles.drawer}>
      <List className={styles.list}>
        <DashboardMenuItem
          key="New Chat"
          text="New Chat"
          icon={<AddBoxOutlinedIcon fontSize="small" />}
          onClick={onNewChat}
          collapsed
        />
      </List>
    </nav>
  )
}
